module.exports = __webpack_public_path__ + "img/AdobeStock_215717753.e536e541.jpeg";